import { Badge, Text } from '@mantine/core';
import { type PayinTrader } from '~/entities/payin';
import { formatPayinTrader, payinTraderStatusColors } from '~/entities/payin';
import { type TableCell, type TableData, type TableRow } from '~/shared/ui/Table';

const prepareHeaders: TableCell[] = [
    { key: 'id', content: 'ID', ta: 'center' },
    { key: 'username', content: 'Username', ta: 'center' },
    { key: 'traderName', content: 'Имя трейдера', ta: 'center' },
    { key: 'status', content: 'Статус', ta: 'center' },
    // { key: 'workingStatus', content: 'Рабочий статус', ta: 'center' },
];

type PrepareTableDataProps = {
    traders?: PayinTrader[];
};

const prepareRows = ({ traders }: PrepareTableDataProps): TableRow<PayinTrader>[] => {
    if (!traders) {
        return [];
    }

    return traders.map((trader) => ({
        key: trader.id?.value ?? 0,
        cells: [
            { key: 'id', content: <Text ta='center'>{trader.id?.value ?? '-'}</Text> },
            { key: 'username', content: <Text ta='center'>{trader.username ?? '-'}</Text> },
            { key: 'traderName', content: <Text ta='center'>{trader.traderName?.value ?? 'Не указано'}</Text> },
            {
                key: 'status',
                content: trader.status ? (
                    <Text
                        ta='center'
                        component='div'
                    >
                        <Badge color={payinTraderStatusColors[trader.status!]}>
                            {formatPayinTrader.status(trader.status!)}
                        </Badge>
                    </Text>
                ) : null,
            },
            // {
            //     key: 'workingStatus',
            //     content: trader.workingStatus ? (
            //         <Text
            //             ta='center'
            //             component='div'
            //         >
            //             <Badge color={payinWorkingStatusColors[trader.workingStatus]}>
            //                 {formatPayinTrader.workingStatus(trader.workingStatus)}
            //             </Badge>
            //         </Text>
            //     ) : null,
            // },
        ],
        item: trader,
    }));
};

export const createTableData = ({ traders }: PrepareTableDataProps): TableData<PayinTrader> => {
    return {
        head: prepareHeaders,
        rows: prepareRows({ traders }),
        caption: traders?.length === 0 ? 'Трейдеров нет' : undefined,
    };
};
